module.exports = __webpack_public_path__ + "static/media/wait-approve.2dc3a868.svg";